var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.label)?_c('div',{staticClass:"icon-button__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.icon)?_c('svgicon',{staticClass:"icon-button__icon",attrs:{"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }